import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { StartupsActive } from './active';
import { StartupsAll } from './all';
import s from './index.module.scss';

const BrandsPage = () => {
  const { t } = useTranslation('brands');
  return (
    <div className={s.startups_page}>
      <div className="container-inner">
        <h1 className={classnames(s.startups_page__title, 'f-42 f-500')}>
          {t('brands_page.title')}
        </h1>
        <StartupsActive />
        <StartupsAll />
      </div>
    </div>
  );
};

export default BrandsPage;
